<template>
  <div class="flex flex-col min-h-screen bg-gray-50">
    <header class="border-b border-gray-200 bg-white">
      <div class="flex items-center gap-4 px-6 py-3">
        <h1 class="text-xl font-bold text-gray-900">Loopback</h1>
        <nav class="flex items-center gap-2">
          <button
            v-for="page in pages"
            :key="page.id"
            @click="uiStore.setCurrentPage(page.id)"
            class="px-3 py-1.5 text-sm rounded-md transition-colors"
            :class="uiStore.currentPage === page.id
              ? 'bg-indigo-50 text-indigo-700 font-medium'
              : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'"
          >
            {{ page.label }}
          </button>
        </nav>
        <div class="flex-1"></div>
        <span class="text-xs text-gray-400">Feedback Platform</span>
      </div>
    </header>

    <main class="flex-1 overflow-hidden">
      <DashboardHome v-if="uiStore.currentPage === 'dashboard'" />
      <FeedbackList v-else-if="uiStore.currentPage === 'feedback'" />
      <FeedbackDetail
        v-else-if="uiStore.currentPage === 'detail'"
        :feedbackId="uiStore.selectedFeedbackId"
      />
    </main>

    <FeedbackWidget />

    <div
      v-if="uiStore.notification"
      class="fixed bottom-4 right-4 px-4 py-2 rounded-lg shadow-lg text-sm text-white transition-all"
      :class="{
        'bg-green-600': uiStore.notification.type === 'success',
        'bg-red-600': uiStore.notification.type === 'error',
        'bg-blue-600': uiStore.notification.type === 'info',
      }"
    >
      {{ uiStore.notification.message }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { useUIStore } from './stores/uiStore'
import DashboardHome from './pages/admin/DashboardHome.vue'
import FeedbackList from './pages/admin/FeedbackList.vue'
import FeedbackDetail from './pages/admin/FeedbackDetail.vue'
import FeedbackWidget from './components/feedback/FeedbackWidget.vue'

const uiStore = useUIStore()

const pages = [
  { id: 'dashboard', label: 'Dashboard' },
  { id: 'feedback', label: 'Feedback' },
]
</script>
